const clientData = [
  {
    id: 1,
    src: "/assets/image/client/bg/1_al_futtam-removebg-preview.png",
    alt: "client 1",
    imgSrc: "/assets/image/client/1_al_futtam.jpg",
  },
  {
    id: 2,
    src: "/assets/image/client/bg/2-SHAPOORJI-removebg-preview.png",
    alt: "client 2",
    imgSrc: "/assets/image/client/2-SHAPOORJI.png",
  },
  {
    id: 3,
    src: "/assets/image/client/bg/3_buhaleeba-removebg-preview.png",
    alt: "client 3",
    imgSrc: "/assets/image/client/3_buhaleeba.jpg",
  },
  {
    id: 4,
    src: "/assets/image/client/bg/4_nasesco-removebg-preview.png",
    alt: "client 4",
    imgSrc: "/assets/image/client/4_nasesco.jpg",
  },
  {
    id: 5,
    src: "/assets/image/client/bg/5_emirates-removebg-preview.png",
    alt: "client 5",
    imgSrc: "/assets/image/client/5_emirates.jpg",
  },
  {
    id: 6,
    src: "/assets/image/client/bg/6_adicc-removebg-preview.png",
    alt: "client 6",
    imgSrc: "/assets/image/client/6_adicc.png",
  },
  {
    id: 7,
    src: "/assets/image/client/bg/7_alrukn-removebg-preview.png",
    alt: "client 7",
    imgSrc: "/assets/image/client/7_alrukn.png",
  },
  {
    id: 8,
    src: "/assets/image/client/bg/8_asgc-removebg-preview.png",
    alt: "client 8",
    imgSrc: "/assets/image/client/8_asgc.jpg",
  },
  {
    id: 9,
    src: "/assets/image/client/bg/9_cdf-removebg-preview.png",
    alt: "client 1",
    imgSrc: "/assets/image/client/9_cdf.png",
  },
  {
    id: 10,
    src: "/assets/image/client/bg/10_emirates-removebg-preview.png",
    alt: "client 2",
    imgSrc: "/assets/image/client/10_emirates.jpg",
  },
  {
    id: 11,
    src: "/assets/image/client/bg/11_lacan-removebg-preview.png",
    alt: "client 3",
    imgSrc: "/assets/image/client/11_lacan.jpg",
  },
  {
    id: 12,
    src: "/assets/image/client/bg/12_doris-removebg-preview.png",
    alt: "client 4",
    imgSrc: "/assets/image/client/12_doris.png",
  },
  {
    id: 13,
    src: "/assets/image/client/bg/13_arabtc-removebg-preview.png",
    alt: "client 5",
    imgSrc: "/assets/image/client/13_arabtc.jpg",
  },
  {
    id: 14,
    src: "/assets/image/client/bg/14_shams-removebg-preview.png",
    alt: "client 6",
    imgSrc: "/assets/image/client/14_shams.png",
  },
  {
    id: 15,
    src: "/assets/image/client/bg/15_gulf-removebg-preview.png",
    alt: "client 7",
    imgSrc: "/assets/image/client/15_gulf.jpg",
  },
  {
    id: 16,
    src: "/assets/image/client/bg/16_dubai-removebg-preview.png",
    alt: "client 8",
    imgSrc: "/assets/image/client/16_dubai.jpg",
  },
  {
    id: 17,
    src: "/assets/image/client/bg/17_evan-removebg-preview.png",
    alt: "client 8",
    imgSrc: "/assets/image/client/17_evan.jpg",
  },
  {
    id: 18,
    src: "/assets/image/client/bg/18_asgc-removebg-preview.png",
    alt: "client 8",
    imgSrc: "/assets/image/client/18_asgc.jpg",
  },
  {
    id: 19,
    src: "/assets/image/client/bg/19_rocky-removebg-preview.png",
    alt: "client 8",
    imgSrc: "/assets/image/client/19_rocky.png",
  },
  {
    id: 20,
    src: "/assets/image/client/bg/20_ideal-removebg-preview.png",
    alt: "client 8",
    imgSrc: "/assets/image/client/20_ideal.jpg",
  },
];

export default clientData;
